@use "variables" as *;

.credits {
  font-size: $fontSize-xs;
  font-weight: normal;
  align-self: end;
  text-align: end;
  padding-right: $spacing-s;
  padding-bottom: $spacing-s;
  white-space: pre;
}
